import $ from 'jquery';
import Inputmask from "inputmask";

class CallbackForm {
    constructor() {
        //new Foundation.Dropdown($("#callback-complete"));

        Inputmask({"mask": "+7 (999) 999-9999"}).mask($('input[type="tel"]'));

        $('[data-callback-send]').on('click', function(e){

            let $form = $(e.currentTarget).closest('form');
            let name = $('[name="name"]', $form).val();
            let phone = $('[name="phone"]', $form).val();
            let grp = $('[name="group"]', $form).val();
            let $input_phone = $('#cb-form-phone');

            $input_phone.on('keyup', function () {
                $('#input-phone-cb').addClass('d-none');
            });

            $('[name="name"]', $form).on('keyup',function () {
                $('#input-name-cb').addClass('d-none');
            });

            const regex = RegExp('^[а-яa-z\\s\\-]{1,30}$','ui');
            if(false === regex.test(name)) {
                $('#input-name-cb').removeClass('d-none');
                return;
            }

            if($input_phone[0].inputmask){
                if(!$input_phone[0].inputmask.isComplete()){
                    $('#input-phone-cb').removeClass('d-none').html('Номер введен не корректно.');
                    return;
                }
            }


            $.post("/q/callback", {"name": name, "phone": phone, "group":grp}, (data) => {
                $('#callback-complete').foundation('open');
                $('#callback-pane').foundation('close');
                if (typeof dataLayer === "object") {
                    dataLayer.push({'event': 'zvonok'});
                }
            });
        });
    }
}

export default CallbackForm;
